import React, { useState } from 'react'
import { notify } from '../utils/ToastUtils';
import TailwindModal from '../components/TailwindModal';
import {
    CalendarDays, Home, Users, ShieldCheck, Mail, LockKeyhole, PackageCheck,
    CircleCheck, KeyRound, UserCheck, ShieldAlert, Key, Laptop, Trash2, Tags,
    FileCheck2, Search, ArrowUpRight
} from 'lucide-react';



function Policies() {
    const [open, setOpen] = useState(false)
    const [pdfURL, setPdfURL] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [activeCategory, setActiveCategory] = useState("All Policies");
    const [searchTerm, setSearchTerm] = useState("");

    const showFile = (fileName, title) => {
        if (fileName) {
            setOpen(true);
            setModalTitle(title || "Policy Document");
            setPdfURL(`/policy-files/${fileName}`)
        } else notify.error("Something went wrong, please try again later")
    }

    const policiesData = [
        {
            id: "01",
            title: "Leave Policy",
            description: "Guidelines and procedures for employee leave, including types of leave, eligibility and application process.",
            date: "May 20, 2026",
            version: "2.1",
            icon: <CalendarDays size={28} strokeWidth={1.8} />,
            bg: "bg-orange-50",
            border: "border-orange-200",
            borderLeft: "border-l-orange-500",
            file: "leave_policy.pdf",
        },
        {
            id: "02",
            title: "WFH Policy",
            description: "Guidelines for remote work arrangements, eligibility, expectations and employee responsibilities.",
            date: "Apr 15, 2026",
            version: "1.7",
            icon: <Home size={28} strokeWidth={1.8} />,
            bg: "bg-purple-50",
            border: "border-purple-200",
            borderLeft: "border-l-purple-500",
            file: "wfh_policy.pdf",
        },
        {
            id: "03",
            title: "Maternity Leave Policy",
            description: "Policy for maternity leave, benefits, duration, and guidelines for expecting and new mothers.",
            date: "Jan 10, 2026",
            version: "1.3",
            icon: <Users size={20} strokeWidth={1.8} />,
            bg: "bg-green-50",
            border: "border-green-200",
            borderLeft: "border-l-green-500",
            file: "maternity_leave_policy.pdf",
        },
        {
            id: "05",
            title: "Policy Compliance",
            description: "Requirements for complying with company security policies.",
            icon: <FileCheck2 size={28} strokeWidth={1.8} />, bg: "bg-blue-50", border: "border-blue-200", borderLeft: "border-l-blue-500",
            file: "policy_compliance.pdf"
        },
        {
            id: "06",
            title: "Email Policy",
            description: "Rules for safe and appropriate use of company email.",
            icon: <Mail size={28} strokeWidth={1.8} />, bg: "bg-fuchsia-50", border: "border-fuchsia-200", borderLeft: "border-l-fuchsia-500",
            file: "email_policy.pdf"
        },
        {
            id: "07",
            title: "Password Protection Policy",
            description: "Requirements for protecting passwords and account credentials.",
            icon: <LockKeyhole size={28} strokeWidth={1.8} />, bg: "bg-rose-50", border: "border-rose-200", borderLeft: "border-l-rose-500",
            file: "password_protection_policy.pdf"
        },
        {
            id: "08",
            title: "Software Installation Policy",
            description: "Guidelines for installing and managing software on company devices.",
            icon: <PackageCheck size={28} strokeWidth={1.8} />, bg: "bg-cyan-50", border: "border-cyan-200", borderLeft: "border-l-cyan-500",
            file: "software_installation_policy.pdf"
        },
        {
            id: "09",
            title: "Acceptable Use Policy",
            description: "Expectations for responsible use of company systems and resources.",
            icon: <CircleCheck size={28} strokeWidth={1.8} />, bg: "bg-teal-50", border: "border-teal-200", borderLeft: "border-l-teal-500",
            file: "acceptable_use_policy.pdf"
        },
        {
            id: "10",
            title: "Password Construction Guidelines",
            description: "Guidance for creating secure passwords.",
            icon: <KeyRound size={28} strokeWidth={1.8} />, bg: "bg-purple-50", border: "border-purple-200", borderLeft: "border-l-purple-500",
            file: "password_construction_guidelines.pdf"
        },
        {
            id: "11",
            title: "Minimum Access Policy",
            description: "Guidelines for limiting access to the minimum needed for each role.",
            icon: <UserCheck size={28} strokeWidth={1.8} />, bg: "bg-emerald-50", border: "border-emerald-200", borderLeft: "border-l-emerald-500",
            file: "minimum_access_policy.pdf"
        },
        {
            id: "12",
            title: "Security Response Plan Policy",
            description: "Plan for responding to security incidents.",
            icon: <ShieldAlert size={28} strokeWidth={1.8} />, bg: "bg-rose-50", border: "border-rose-200", borderLeft: "border-l-rose-500",
            file: "security_response_plan_policy.pdf"
        },
        {
            id: "13",
            title: "End User Encryption Key Protection Policy",
            description: "Requirements for protecting encryption keys used by end users.",
            icon: <Key size={28} strokeWidth={1.8} />, bg: "bg-amber-50", border: "border-amber-200", borderLeft: "border-l-amber-500",
            file: "end_user_encryption_key_protection_policy.pdf"
        },
        {
            id: "14",
            title: "Laptop Storage and Security Policy",
            description: "Guidelines for secure laptop storage and handling.",
            icon: <Laptop size={28} strokeWidth={1.8} />, bg: "bg-slate-50", border: "border-slate-200", borderLeft: "border-l-slate-500",
            file: "laptop_storage_and_security_policy.pdf"
        },
        {
            id: "15",
            title: "Data Protection Standard Policy",
            description: "Standards for protecting company and customer data.",
            icon: <ShieldCheck size={28} strokeWidth={1.8} />, bg: "bg-lime-50", border: "border-lime-200", borderLeft: "border-l-lime-500",
            file: "data_protection_standard_policy.pdf"
        },
        {
            id: "16",
            title: "Data Deletion Policy",
            description: "Guidelines for securely deleting data when it is no longer needed.",
            icon: <Trash2 size={28} strokeWidth={1.8} />, bg: "bg-orange-50", border: "border-orange-200", borderLeft: "border-l-orange-500",
            file: "data_deletion_policy.pdf"
        },
        {
            id: "17",
            title: "Data Classification Policy",
            description: "Guidelines for classifying data and handling it according to sensitivity.",
            icon: <Tags size={28} strokeWidth={1.8} />, bg: "bg-fuchsia-50", border: "border-fuchsia-200", borderLeft: "border-l-fuchsia-500",
            file: "data_classification_policy.pdf"
        }
    ];

    const policyCategories = {
        "01": "HR", "02": "HR", "03": "HR",
        "06": "IT", "07": "IT", "08": "IT", "10": "IT", "11": "IT",
        "05": "Security", "09": "Security", "12": "Security", "13": "Security",
        "14": "Security", "15": "Security", "16": "Security", "17": "Security"
    };
    const iconColors = {
        "01": "text-orange-600", "02": "text-violet-600", "03": "text-emerald-600",
        "05": "text-blue-600", "06": "text-fuchsia-600",
        "07": "text-rose-600", "08": "text-cyan-600", "09": "text-teal-600",
        "10": "text-purple-600", "11": "text-green-600", "12": "text-red-600",
        "13": "text-amber-600", "14": "text-slate-600", "15": "text-lime-700",
        "16": "text-orange-700", "17": "text-pink-600"
    };
    const categories = [
        { label: "All Policies", value: "All Policies" },
        { label: "Leave Policies", value: "HR" },
        { label: "IT Policies", value: "IT" },
        { label: "Security & Data", value: "Security" }
    ];
    const filteredPolicies = policiesData.filter((policy) => {
        const matchesCategory = activeCategory === "All Policies" || policyCategories[policy.id] === activeCategory;
        const query = searchTerm.trim().toLowerCase();
        const matchesSearch = !query || `${policy.title} ${policy.description}`.toLowerCase().includes(query);
        return matchesCategory && matchesSearch;
    });
    const categoryCount = (category) => category === "All Policies"
        ? policiesData.length
        : policiesData.filter((policy) => policyCategories[policy.id] === category).length;

    return (
        <div className="flex flex-col w-full flex-1" style={{ fontFamily: '"Inter", sans-serif' }}>
            <div className="flex-1 flex flex-col gap-4 p-4 sm:p-6 !pt-0">
                <div className="sticky top-0 z-20 flex flex-col gap-3 rounded-xl border border-slate-200 bg-white p-3 shadow-sm lg:flex-row lg:items-center lg:justify-between">
                    <div className="flex flex-wrap items-center gap-1.5">
                        {categories.map((category) => {
                            const selected = activeCategory === category.value;
                            return (
                                <button key={category.value} type="button" onClick={() => setActiveCategory(category.value)}
                                    className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-[11px] font-semibold transition-colors ${selected ? "border-blue-600 bg-blue-600 text-white shadow-sm" : "border-slate-200 bg-white text-slate-600 hover:border-blue-200 hover:bg-blue-50"}`}>
                                    {category.label}
                                    <span className={`rounded-full px-1.5 py-0.5 text-[9px] ${selected ? "bg-white/20 text-white" : "bg-slate-100 text-slate-500"}`}>
                                        {categoryCount(category.value)}
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                    <label className="relative block w-full lg:max-w-[280px]">
                        <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
                        <input type="search" value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)}
                            placeholder="Search policies..." aria-label="Search policies"
                            className="w-full rounded-lg border border-slate-200 bg-white py-2 pl-8 pr-2.5 text-xs text-slate-700 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100" />
                    </label>
                </div>
                <div className="space-y-2">
                    {filteredPolicies.length === 0 ? (
                        <div className="rounded-xl border border-dashed border-slate-300 bg-white px-4 py-10 text-center text-sm text-slate-500">
                            No policies match your search.
                        </div>
                    ) : filteredPolicies.map((policy) => (
                    <div key={policy.id} className={`bg-white rounded-xl border border-slate-200 border-l-[3px] ${policy.borderLeft} p-2.5 flex items-center justify-between gap-2.5 shadow-sm hover:shadow-md transition-shadow`}>
                        <div className="flex items-center gap-2.5 flex-grow min-w-0">
                            <div className={`w-10 h-10 ${policy.bg} rounded-lg flex items-center justify-center shrink-0`}>
                                {React.cloneElement(policy.icon, { size: 18, width: 18, height: 18, className: iconColors[policy.id] })}
                            </div>
                            
                            <div className="flex flex-col">
                                <h2 className="text-[13px] font-bold text-slate-800 mb-0.5">{policy.title}</h2>
                                <p className="text-[11px] text-slate-500 m-0 leading-relaxed">{policy.description}</p>
                                
                                {/* <div className="flex items-center gap-6 text-xs text-slate-400 font-medium">
                                    <div className="flex items-center gap-1.5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/></svg>
                                        Last updated: {policy.date}
                                    </div>
                                    <div className="flex items-center gap-1.5 border-l border-slate-200 pl-6">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" x2="8" y1="13" y2="13"/><line x1="16" x2="8" y1="17" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                                        Version {policy.version}
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        <button 
                            onClick={() => showFile(policy.file, policy.title)}
                            className="w-auto px-2.5 sm:px-3.5 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-[11px] font-semibold shadow-sm flex items-center justify-center gap-1 shrink-0"
                        >
                            <span className="hidden sm:inline">View Policy</span><span className="sm:hidden">View</span>
                            <ArrowUpRight size={13} />
                        </button>
                    </div>
                ))}
            </div>

            <div className="bg-blue-50/50 border border-blue-100 rounded-xl p-2 flex items-center gap-3 w-fit">
                <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="12" x2="12" y1="16" y2="12"/><line x1="12" x2="12.01" y1="8" y2="8"/></svg>
                </div>
                <p className="text-xs text-slate-600 m-0 font-medium">Policies are reviewed and updated periodically. Please check back for the latest updates.</p>
            </div>
            </div>

            <TailwindModal maxWidth="3xl" isOpen={open} toggle={() => setOpen(!open)}>
                <div className="flex flex-col bg-white overflow-hidden max-h-[96vh]" style={{ borderRadius: '20px' }}>
                    <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between bg-slate-50/50 shrink-0">
                        <h2 className="text-base font-bold text-slate-800 flex items-center gap-2 m-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
                            {modalTitle}
                        </h2>
                        <button onClick={() => setOpen(false)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-200 text-slate-500 transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                        </button>
                    </div>
                    <div className="p-2 sm:p-3 bg-slate-50/50 flex-1 overflow-y-auto">
                        <div className="bg-white rounded-xl p-1 shadow-sm border border-slate-200 min-h-[76vh] h-full flex flex-col">
                            <iframe
                                title="PDF Viewer"
                                src={`${pdfURL}#page=1&zoom=page-fit`}
                                style={{ width: '100%', height: '100%', minHeight: '76vh' }}
                                className="rounded-lg bg-slate-50 block flex-1"
                            />
                        </div>
                    </div>
                    <div className="px-4 py-2 border-t border-slate-100 flex justify-end bg-white shrink-0">
                        <button className="px-4 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all text-xs font-semibold shadow-[0_4px_12px_rgba(37,99,235,0.2)]" onClick={() => setOpen(false)}>
                            Close
                        </button>
                    </div>
                </div>
            </TailwindModal>

        </div>
    )
}

export default Policies
